<template>
  <div class="not-found-container">
    <div class="not-found-content">
      <!-- 404 图标/动画 -->
      <div class="error-code">404</div>
      
      <!-- 错误信息 -->
      <div class="error-message">
        <h2>页面未找到</h2>
        <p>抱歉，您访问的页面不存在或已被移除</p>
      </div>
      
      <!-- 操作按钮 -->
      <div class="error-actions">
        <el-button 
          type="primary" 
          size="large" 
          @click="$router.push('/')"
        >
          <el-icon><HomeFilled /></el-icon>返回首页
        </el-button>
        <el-button 
          type="default" 
          size="large" 
          @click="$router.go(-1)"
          :disabled="!canGoBack"
        >
          <el-icon><ArrowLeft /></el-icon>返回上一页
        </el-button>
      </div>
    </div>
    
    <!-- 装饰元素 -->
    <div class="decor-element decor-1"></div>
    <div class="decor-element decor-2"></div>
    <div class="decor-element decor-3"></div>
  </div>
</template>

<script setup>
import { HomeFilled, ArrowLeft } from '@element-plus/icons-vue';
import { ref, onMounted } from 'vue';

// 判断是否可以返回上一页
const canGoBack = ref(false);

onMounted(() => {
  // 检查浏览器历史记录长度
  canGoBack.value = window.history.length > 1;
});
</script>

<style scoped>
.not-found-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f5f7fa;
  overflow: hidden;
}

.not-found-content {
  position: relative;
  z-index: 10;
  text-align: center;
  padding: 40px;
  background-color: white;
  border-radius: 16px;
  box-shadow: 0 10px 50px rgba(0, 0, 0, 0.08);
  max-width: 600px;
  width: 90%;
}

.error-code {
  font-size: 120px;
  font-weight: 900;
  background: linear-gradient(135deg, #165DFF, #7B61FF);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  margin-bottom: 20px;
  line-height: 1;
  position: relative;
  animation: float 6s ease-in-out infinite;
}

@keyframes float {
  0% { transform: translateY(0px); }
  50% { transform: translateY(-20px); }
  100% { transform: translateY(0px); }
}

.error-message h2 {
  font-size: 28px;
  color: #333;
  margin-bottom: 15px;
}

.error-message p {
  font-size: 16px;
  color: #666;
  margin-bottom: 30px;
  line-height: 1.6;
}

.error-actions {
  display: flex;
  gap: 15px;
  justify-content: center;
  margin-top: 20px;
}

/* 装饰元素 */
.decor-element {
  position: absolute;
  border-radius: 50%;
  background: rgba(22, 93, 255, 0.05);
  z-index: 1;
}

.decor-1 {
  width: 400px;
  height: 400px;
  top: -100px;
  left: -100px;
}

.decor-2 {
  width: 300px;
  height: 300px;
  bottom: -50px;
  right: -50px;
  background: rgba(123, 97, 255, 0.05);
}

.decor-3 {
  width: 150px;
  height: 150px;
  top: 30%;
  right: 15%;
  background: rgba(22, 93, 255, 0.08);
}
</style>
    